import { render, staticRenderFns } from "./ShareIndex.vue?vue&type=template&id=4701583f&scoped=true&"
import script from "./ShareIndex.vue?vue&type=script&lang=js&"
export * from "./ShareIndex.vue?vue&type=script&lang=js&"
import style0 from "../../static/scss/shareindex.scss?vue&type=style&index=0&id=4701583f&scoped=true&lang=scss&"
import style1 from "./ShareIndex.vue?vue&type=style&index=1&id=4701583f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4701583f",
  null
  
)

export default component.exports